import React, { useState, useEffect } from "react";

export const Marker = (options) => {
  const [marker, setMarker] = useState();
  const [infoWindow, setInfoWindow] = useState();

  useEffect(() => {
    if (!marker) {
      setMarker(new window.google.maps.Marker());
      if (options.infoWindowContent) {
        setInfoWindow(new window.google.maps.InfoWindow());
      }
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  useEffect(() => {
    if (marker) {
      marker.setOptions(options);
      if (infoWindow) {
        marker.addListener("click", () => {
          openInfoWindow();
        });

        openInfoWindow();
      }
    }
  }, [marker, options]);

  const openInfoWindow = () => {
    if (!infoWindow) return;

    const contentString = `
      <div class="tiny-text d-flex px-2 py-2 align-items-center">
        <div class="p-0 flex-grow-1">
          ${options.infoWindowContent}
        </div>
        <div>
          <span class='font-weight-bold px-2' onclick="this.closest('.gm-style-iw').parentNode.style.display='none'" style="cursor: pointer;">X</span>
        </div>
      </div>
    `;

    infoWindow.setContent(contentString);
    infoWindow.open(marker.map, marker);
  };

  return null;
};
